export default __webpack_public_path__ + "static/media/big-light-violet-done.64e438fd.svg";